import { ButtonBrand } from 'components/ButtonBrand';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { FAQs } from 'components/Faqs';

export const FAQsSection = () => {
  return (
    <div className="faqs-section-container">
      <div className="faqs-section-title">
        <FadeText inViewTrigger progressive className="h1-dtm" text="Frequently Asked Questions" />
        <FadeText
          inViewTrigger
          className="h4-text"
          text="For more information about Oath, visit Oath’s Help Center."
        />
        <ButtonBrand to="https://helpcenter.oath.vote/oath-help-center" target="_blank" $secondary>
          Visit Help Center
        </ButtonBrand>
      </div>
      <FadeContainer className="faqs-section-content" inViewTrigger delay={0.2}>
        <FAQs isDarkBackground />
      </FadeContainer>
    </div>
  );
};
